<div fxLayout="column" fxLayoutAlign="start start" style="width: 100%" class="layout fill api-key-container">
  <div fxLayout="row" fxLayoutAlign="space-between start" style="width: 100%">
    <span class="mat-headline-5">API Keys</span>
    <button mat-flat-button color="primary" class="new-api-key-button" routerLink="/admin/api-key/new">+ NEW API KEY</button>
  </div>

  <ifc-broker-api-key-list [inputData]="data"></ifc-broker-api-key-list>
</div>
